import React, { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { BUTTONS, HEADINGS } from "@/utils/constants/appConstants/commonConstants";
import { CheckboxCard } from "@/components/cards/CheckboxCard";
import NoDataAvailable from "@/components/cards/NoDataAvailable";
import { ToggleListSkeleton } from "@/components/skeletons";
import { Button } from "@/components/ui/button";
import { fetchAllGroups } from "@/services/group.service";

interface AddGroupsModalProps {
    show?: boolean;
    onHide?: () => void;
    usergroups: any[];
    setUserGroups: (groups: any[]) => void;
}

function AddGroupsModal(props: AddGroupsModalProps) {
    const [allGroups, setAllGroups] = useState<any>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (props.usergroups.length === 0) {
            setAllGroups(allGroups.map((group: any) => ({ ...group, checked: false })));
        }
    }, [props.usergroups.length]);

    const getGroupsListFromAPI = () => {
        setLoading(true);
        fetchAllGroups((response: any) => {
            setLoading(false);
            const new_groups_list = response?.data?.groups.map((group: { checked: boolean; name: any }) => {
                group.checked = props.usergroups?.some((obj: { name: any }) => obj.name === group.name) ? true : false;
                return group;
            });
            setAllGroups(new_groups_list);
        }, (error: any) => { setLoading(false); console.log(error); });
    };

    useEffect(() => { getGroupsListFromAPI(); }, []);

    const onChangeGroup = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAllGroups(allGroups.map((group: any) =>
            e.target.name === group.name ? { ...group, checked: e.target.checked } : group
        ));
    };

    const handleGroups = () => {
        props.setUserGroups(allGroups.filter((group: any) => group.checked));
        props.onHide?.();
    };

    return (
        <Dialog open={props.show} onOpenChange={(open) => { if (!open) props.onHide?.(); }}>
            <DialogContent className="gs-tag-dialog gs-tag-dialog--wide">
                <div className="gs-tag-dialog__header">
                    <h4 className="gs-tag-dialog__title" id="add-group-title">
                        {HEADINGS.ADD_GROUPS}
                    </h4>
                </div>

                <div className="gs-tag-dialog__body gs-tag-dialog__body--list">
                    <ul className="gs-picker-dialog-list">
                        {loading ? (
                            <ToggleListSkeleton rowCount={5} labelWidth="11.25rem" />
                        ) : allGroups.length > 0 ? (
                            allGroups.map((group: any, key: number) => (
                                <li key={group.id}>
                                    <CheckboxCard index={key} onChange={onChangeGroup} name={group.name} id={group.id} checked={group.checked}>
                                        <span id={`group-name-${key}`}>{group.name}</span>
                                    </CheckboxCard>
                                </li>
                            ))
                        ) : (
                            <li className="gs-picker-dialog-empty">
                                <NoDataAvailable>
                                    <h4 className="text-center" id="no-group-data-msg">
                                        No Group Yet.
                                    </h4>
                                </NoDataAvailable>
                            </li>
                        )}
                    </ul>
                </div>

                <div className="gs-tag-dialog__footer">
                    <Button id="add-group-done-btn" className="gs-tag-dialog__submit" onClick={handleGroups}>
                        {BUTTONS.ADD}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default AddGroupsModal;
